/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Accesibility } from '../../assets/themes/OPL/img/icons/Accesibility.svg';

function ViewButton({ ...props }) {
    const { classes, callback, callbackParam, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={Accesibility}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

ViewButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default ViewButton;
